import type { TWidget } from 'widgets/Widget';

/**
 * @param ProductBreadcrumbs Base widget for extending
 * @returns ProductBreadcrumbs widget
 */
function ProductBreadcrumbsClassCreator(Widget: TWidget) {
    class ProductBreadcrumbs extends Widget {
        prefs() {
            return {
                ...super.prefs()
            };
        }

        init() {
            super.init();

            this.eventBus().on('updatebreadcrumbs', 'updateBreadcrumbs');
        }

        /**
         * @description Updates the product breadcrumbs
         */
        updateBreadcrumbs({ newUrl, productName }): void {
            const breadcrumbItem = this.ref('lastBreadcrumbItem').get();
            const lastBreadcrumbLink = breadcrumbItem ? breadcrumbItem.querySelector('a') : null;

            if (lastBreadcrumbLink) {
                lastBreadcrumbLink.setAttribute('href', newUrl);

                if (productName) {
                    lastBreadcrumbLink.textContent = productName;
                }
            }
        }
    }

    return ProductBreadcrumbs;
}

export type TProductBreadcrumbs = ReturnType<typeof ProductBreadcrumbsClassCreator>;

export type TProductBreadcrumbsInstance = InstanceType<TProductBreadcrumbs>;

export default ProductBreadcrumbsClassCreator;
